/* F.G. Edwards homepage system: section tracking, quick add, store open status. */
(function () {
  'use strict';
  if (window.__fgHome) return;
  window.__fgHome = true;

  /* The script is injected by the first fg-home section, so it can run before the sections further
     down the page exist. Everything below waits for the whole document. */
  function boot() {

  /* ---------- Expiry guard ----------
     Dated content is switched off on the server. Pages can be served from cache for a while, so anything
     whose end date has already passed in the shop's time zone is removed here as a second line of defence. */
  (function () {
    if (window.Shopify && Shopify.designMode) return;
    var today;
    try {
      today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    } catch (e) { return; }
    document.querySelectorAll('[data-fgh-until]').forEach(function (el) {
      var until = el.getAttribute('data-fgh-until');
      if (/^\d{4}-\d{2}-\d{2}$/.test(until) && today > until) {
        var grid = el.closest('.fgh-hero__grid');
        el.parentNode.removeChild(el);
        if (grid) {
          var left = grid.querySelectorAll('.fgh-tile').length;
          grid.className = grid.className.replace(/fgh-hero__grid--\d/, 'fgh-hero__grid--' + left);
          var first = grid.querySelector('.fgh-tile');
          if (first) { first.classList.remove('fgh-tile--side'); first.classList.add('fgh-tile--lead'); if (left === 1) first.classList.add('fgh-tile--solo'); }
          if (!left) { var sec = grid.closest('.fgh'); if (sec) sec.parentNode.removeChild(sec); }
        }
      }
    });
  })();

  /* ---------- Tracking ----------
     GA4 runs inside Shopify's web pixel sandbox, so there is no gtag on the page.
     Events go out through Shopify.analytics.publish and a custom pixel forwards them to GA4
     (see docs/homepage-audit/tools/tracking-custom-pixel.js). dataLayer and gtag are used too if present. */
  function send(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data); } catch (e) {}
  }

  /* Actions that lead to a store visit or a local order. One event name, so GA4 can report
     "local actions per homepage session" as the page's primary KPI. */
  var LOCAL_ACTIONS = { directions: 1, phone: 1, store_hours: 1, delivery_info: 1, pickup_info: 1, reviews: 1, postal_check: 1 };

  function sectionInfo(el) {
    var sec = el.closest('[data-fgh-section]');
    if (!sec) return null;
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-fgh-section]'));
    return {
      section: sec.getAttribute('data-fgh-section'),
      section_variant: sec.getAttribute('data-fgh-variant') || '',
      section_position: all.indexOf(sec) + 1
    };
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-fgh-item]');
    if (!item) return;
    var info = sectionInfo(item);
    if (!info) return;
    var sec = item.closest('[data-fgh-section]');
    var items = Array.prototype.slice.call(sec.querySelectorAll('[data-fgh-item]'));
    info.item = item.getAttribute('data-fgh-item');
    info.item_position = items.indexOf(item) + 1;
    info.action = item.getAttribute('data-fgh-action') || 'click';
    var href = item.getAttribute('href');
    if (href) info.destination = href.split('?')[0];
    send('fg_home_click', info);
    if (LOCAL_ACTIONS[info.action]) send('fg_home_local_action', info);
  }, true);

  /* Header: store widget, phone and search, so local intent on the homepage is measurable. */
  function headerEvent(item, action) {
    var info = { section: 'header', section_variant: '', section_position: 0, item: item, item_position: 0, action: action };
    send('fg_home_click', info);
    if (LOCAL_ACTIONS[action]) send('fg_home_local_action', info);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fg-hours-toggle]')) return headerEvent('store-hours', 'store_hours');
    var tel = e.target.closest('.shopify-section-group-header-group a[href^="tel:"]');
    if (tel) return headerEvent('phone', 'phone');
    var maps = e.target.closest('.fg-hours__maps-btn');
    if (maps) return headerEvent('directions', 'directions');
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.closest('.shopify-section-group-header-group form[action*="/search"]')) headerEvent('search', 'search');
  }, true);

  if ('IntersectionObserver' in window) {
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || seen.has(entry.target)) return;
        seen.add(entry.target);
        io.unobserve(entry.target);
        var info = sectionInfo(entry.target);
        if (info) send('fg_home_view', info);
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('[data-fgh-section]').forEach(function (s) { io.observe(s); });
  }

  /* ---------- Quick add ---------- */
  function refreshCart(json) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && json && json.sections) {
      try { drawer.classList.remove('is-empty'); drawer.renderContents(json); return; } catch (e) {}
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) bubble.click();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fgh-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.querySelector('[data-fgh-add-label]') || btn;
    var original = label.textContent;
    var body = new URLSearchParams();
    body.append('id', btn.getAttribute('data-fgh-add'));
    body.append('quantity', '1');
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      } catch (err) {}
    }
    btn.setAttribute('aria-busy', 'true');
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body.toString()
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (r) {
        btn.removeAttribute('aria-busy');
        if (!r.ok || r.json.status) {
          label.textContent = btn.getAttribute('data-error-label') || original;
          setTimeout(function () { label.textContent = original; }, 2500);
          return;
        }
        btn.classList.add('is-added');
        label.textContent = btn.getAttribute('data-added-label') || original;
        setTimeout(function () { btn.classList.remove('is-added'); label.textContent = original; }, 2200);
        refreshCart(r.json);
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) { bubble.classList.remove('fgh-bump'); void bubble.offsetWidth; bubble.classList.add('fgh-bump'); }
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        window.location.href = btn.getAttribute('data-fallback-url') || '/cart';
      });
  });

  /* ---------- Localised dates (weekly end date) ---------- */
  document.querySelectorAll('[data-fgh-date]').forEach(function (el) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.getAttribute('datetime') || '');
    if (!m) return;
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    try {
      el.textContent = new Intl.DateTimeFormat(en ? 'en-CA' : 'fr-CA', { day: 'numeric', month: 'long' })
        .format(new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10)));
    } catch (e) {}
  });

  /* ---------- Store open status ---------- */
  function nowInStoreTz() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (p) { map[p.type] = p.value; });
      var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return { day: days[map.weekday], mins: (parseInt(map.hour, 10) % 24) * 60 + parseInt(map.minute, 10) };
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), mins: d.getHours() * 60 + d.getMinutes() };
    }
  }
  function parseRange(str) {
    var m = /(\d{1,2})[:h](\d{2})\s*-\s*(\d{1,2})[:h](\d{2})/.exec(str || '');
    if (!m) return null;
    return { open: parseInt(m[1], 10) * 60 + parseInt(m[2], 10), close: parseInt(m[3], 10) * 60 + parseInt(m[4], 10) };
  }
  function fmt(mins, en) {
    var h = Math.floor(mins / 60), m = mins % 60;
    if (en) {
      var ap = h >= 12 ? 'p.m.' : 'a.m.';
      var h12 = h % 12 === 0 ? 12 : h % 12;
      return h12 + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ' ' + ap;
    }
    return h + ' h' + (m ? ' ' + (m < 10 ? '0' : '') + m : '');
  }
  function updateStores() {
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var now = nowInStoreTz();
    var cal = window.FGStoreCalendar;
    var todayIso = cal ? cal.today() : null;
    function closedOn(offset) { return cal && todayIso ? cal.closure(cal.addDays(todayIso, offset)) : null; }
    var holiday = closedOn(0);
    document.querySelectorAll('[data-fgh-store]').forEach(function (el) {
      var hours;
      try { hours = JSON.parse(el.getAttribute('data-hours')); } catch (e) { return; }
      var text = el.querySelector('[data-fgh-status-text]');
      var today = holiday ? null : parseRange(hours[now.day]);
      var open = today && now.mins >= today.open && now.mins < today.close;
      el.classList.toggle('is-open', !!open);
      el.classList.toggle('is-closed', !open);
      if (!text) return;
      if (open) {
        text.textContent = (el.getAttribute('data-open-label') || '').replace('{time}', fmt(today.close, en));
        return;
      }
      if (today && now.mins < today.open) {
        text.textContent = (el.getAttribute('data-opens-today-label') || '').replace('{time}', fmt(today.open, en));
        return;
      }
      for (var i = 1; i <= 14; i++) {
        if (closedOn(i)) continue;
        var d = (now.day + i) % 7;
        var r = parseRange(hours[d]);
        if (!r) continue;
        var dayName = new Intl.DateTimeFormat(en ? 'en-CA' : 'fr-CA', { weekday: 'long' }).format(new Date(2026, 1, 1 + d));
        var label;
        if (holiday && el.getAttribute('data-holiday-label')) {
          label = el.getAttribute('data-holiday-label').replace('{holiday}', en ? holiday.en : holiday.fr);
          if (i === 1) dayName = en ? 'tomorrow' : 'demain';
        } else {
          label = i === 1 ? (el.getAttribute('data-opens-tomorrow-label') || '') : (el.getAttribute('data-opens-day-label') || '');
        }
        text.textContent = label.replace('{day}', dayName).replace('{time}', fmt(r.open, en));
        return;
      }
      text.textContent = el.getAttribute('data-closed-label') || '';
    });
  }
  updateStores();
  setInterval(updateStores, 60000);

  /* ---------- One product, one place ----------
     A product shows in only one homepage rail on a given day: the first rail on the page keeps it.
     Rails render a few hidden spare cards so a rail that loses a duplicate keeps its length. */
  (function () {
    if (window.Shopify && Shopify.designMode) return;
    var seen = {};
    /* The vitrine's products count as shown: they do not repeat in the rows below. */
    /* Only what is on screen at this width: the phone shelf holds more products than the desktop banner. */
    document.querySelectorAll('.fgh-vitrine [data-fgh-product]').forEach(function (el) { if (el.offsetParent === null) return; seen[el.getAttribute('data-fgh-product')] = 1; });
    document.querySelectorAll('[data-fgh-section] .fgh-rail').forEach(function (ul) {
      /* Rails filled later in the browser start empty: leave them alone. */
      if (!ul.children.length) return;
      var max = parseInt(ul.getAttribute('data-fgh-max') || '0', 10);
      var kept = 0;
      var waiting = [];
      /* Variety (docs/homepage-audit/25): a row shows at most two products of one kind while it has something
         else to show; spares of a kind that is already there twice wait, and fill the row only if nothing else can. */
      var kinds = {}, held = [];
      function take(li, handle, card, spare) {
        if (spare) {
          li.removeAttribute('hidden'); li.removeAttribute('data-fgh-spare');
          if (!card) { li.className = 'fgh-card-wait'; waiting.push({ li: li, handle: handle }); }
        }
        var k = li.getAttribute('data-fgh-kind');
        if (k) kinds[k] = (kinds[k] || 0) + 1;
        seen[handle] = 1;
        kept++;
      }
      function drop(li) { if (li.parentNode) li.parentNode.removeChild(li); }
      Array.prototype.slice.call(ul.children).forEach(function (li) {
        var card = li.querySelector('[data-fgh-product]');
        /* A spare is only a handle until it is needed (docs/homepage-audit/25). */
        var handle = card ? card.getAttribute('data-fgh-product') : li.getAttribute('data-fgh-spare-handle');
        if (!handle) return;
        var spare = li.hasAttribute('data-fgh-spare');
        if (seen[handle]) { drop(li); return; }
        if (!spare) { take(li, handle, card, false); return; }
        if (!max) { drop(li); return; }
        var k = li.getAttribute('data-fgh-kind');
        if (k && (kinds[k] || 0) >= 2) { held.push({ li: li, handle: handle, card: card }); return; }
        if (kept >= max) { drop(li); return; }
        take(li, handle, card, true);
      });
      held.forEach(function (h) {
        if (kept >= max || seen[h.handle]) { drop(h.li); return; }
        take(h.li, h.handle, h.card, true);
      });
      if (waiting.length) {
        whenNear(ul, function () {
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          waiting.forEach(function (w) {
            getHtml(root + 'products/' + encodeURIComponent(w.handle) + '?section_id=fg-home-card-render').then(function (html) {
              var got = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fgh-render] > li');
              if (!got || !got.children.length) throw new Error('no card');
              w.li.className = '';
              w.li.innerHTML = got.innerHTML;
            }).catch(function () { if (w.li.parentNode) w.li.parentNode.removeChild(w.li); });
          });
        });
      }
      if (!kept) {
        /* A department row goes alone; a seasonal module keeps its panel; a rail-only section goes away entirely. */
        /* A duo loses only its emptied side; a department row goes alone. */
        var side = ul.hasAttribute('data-fgh-row') ? ul.closest('.fgh-row__side') : null;
        var row = ul.hasAttribute('data-fgh-row') ? ul.closest('.fgh-row') : null;
        if (side && row && row.querySelectorAll('.fgh-row__side').length > 1) { side.parentNode.removeChild(side); row.classList.add('fgh-row--single'); return; }
        if (row) { row.parentNode.removeChild(row); return; }
        var sec = ul.closest('.fgh');
        if (sec && !sec.classList.contains('fgh-season')) sec.parentNode.removeChild(sec);
        else ul.parentNode.removeChild(ul);
      }
    });
  })();

  /* ---------- Duo tabs (phones) ----------
     On phones a duo shows one department at a time under two tabs; on desktop the tabs are hidden and both show. */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-fgh-duo-tab]');
    if (!tab) return;
    var row = tab.closest('.fgh-row');
    row.querySelectorAll('[data-fgh-duo-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('is-active', on);
    });
    var panel = document.getElementById(tab.getAttribute('aria-controls'));
    var rail = panel && panel.querySelector('.fgh-rail');
    if (rail) rail.scrollLeft = 0;
  });

  /* ---------- Postal code check ----------
     Uses the delivery page's own zone data (fetched once, on first use), so the homepage and
     /pages/livraison always agree. The next delivery date skips store closures and applies the
     cut-off: midnight the night before, so the earliest delivery is tomorrow. */
  var zonesPromise = null;
  function loadZones(url) {
    if (zonesPromise) return zonesPromise;
    zonesPromise = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        function read(id) { var el = doc.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
        var data = { fsas: read('fge-eligible-fsas'), zones: read('fge-zone-map'), days: read('fge-delivery-days') };
        if (!Array.isArray(data.fsas) || !data.fsas.length) throw new Error('data');
        return data;
      });
    zonesPromise.catch(function () { zonesPromise = null; });
    return zonesPromise;
  }
  function routeDays(code, data) {
    if (!data.zones || !data.days) return [];
    var best = 0, zones = [];
    Object.keys(data.zones).forEach(function (prefix) {
      if (code.indexOf(prefix) !== 0) return;
      var z = data.zones[prefix];
      z = Array.isArray(z) ? z : [z];
      if (prefix.length > best) { best = prefix.length; zones = z.slice(); }
      else if (prefix.length === best) z.forEach(function (x) { if (zones.indexOf(x) < 0) zones.push(x); });
    });
    var days = [];
    zones.forEach(function (z) { var d = data.days[z]; if (typeof d === 'number' && days.indexOf(d) < 0) days.push(d); });
    return days.sort();
  }
  function nextDelivery(days) {
    var cal = window.FGStoreCalendar;
    if (!cal || !days.length) return null;
    var today = cal.today();
    for (var i = 1; i <= 35; i++) {
      var date = cal.addDays(today, i);
      if (days.indexOf(cal.weekday(date)) > -1 && !cal.closure(date)) return { date: date, offset: i };
    }
    return null;
  }
  function longDate(isoDate, en, withWeekday) {
    var p = isoDate.split('-');
    var opts = withWeekday ? { weekday: 'long', day: 'numeric', month: 'long' } : { weekday: 'long' };
    return new Intl.DateTimeFormat(en ? 'en-CA' : 'fr-CA', opts).format(new Date(+p[0], +p[1] - 1, +p[2]));
  }
  function joinDays(days, en) {
    var names = days.map(function (d) { return new Intl.DateTimeFormat(en ? 'en-CA' : 'fr-CA', { weekday: 'long' }).format(new Date(2026, 1, 1 + d)); });
    if (names.length < 2) return names.join('');
    return names.slice(0, -1).join(', ') + (en ? ' or ' : ' ou ') + names[names.length - 1];
  }
  document.querySelectorAll('[data-fgh-postal]').forEach(function (form) {
    var input = form.querySelector('[data-fgh-postal-input]');
    var out = form.querySelector('[data-fgh-postal-result]');
    var source = form.getAttribute('data-source');
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    function msg(key) { return form.getAttribute('data-msg-' + key) || ''; }
    function show(state, html) {
      out.className = 'fgh-postal__result is-' + state;
      out.innerHTML = html;
    }
    function track(result, fsa, days) {
      send('fg_home_local_action', { section: 'local-service', section_variant: 'postal', section_position: 0, item: 'postal-check', item_position: 0, action: 'postal_check', result: result, fsa: fsa || '', route_days: (days || []).join(',') });
    }
    input.addEventListener('focus', function () { loadZones(source).catch(function () {}); }, { once: true });
    input.addEventListener('input', function () {
      var v = input.value.replace(/\s/g, '').toUpperCase().slice(0, 6);
      input.value = v.length > 3 ? v.slice(0, 3) + ' ' + v.slice(3) : v;
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = input.value.replace(/\s/g, '').toUpperCase();
      if (!/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(code)) { show('error', msg('invalid')); input.focus(); track('invalid'); return; }
      var fsa = code.slice(0, 3);
      form.setAttribute('aria-busy', 'true');
      loadZones(source).then(function (data) {
        form.removeAttribute('aria-busy');
        var eligible = data.fsas.some(function (p) { return code.indexOf(p) === 0; });
        if (!eligible) {
          show('no', msg('no').replace('{fsa}', fsa));
          track('outside', fsa);
          return;
        }
        var days = routeDays(code, data);
        var next = nextDelivery(days);
        if (!next) { show('ok', msg('ok-general')); track('eligible', fsa, days); return; }
        var cutoff = next.offset === 1 ? msg('cutoff-tonight') : msg('cutoff-day').replace('{day}', longDate(window.FGStoreCalendar.addDays(next.date, -1), en, false));
        show('ok', msg('ok').replace('{days}', joinDays(days, en)).replace('{date}', longDate(next.date, en, true)).replace('{cutoff}', cutoff));
        track('eligible', fsa, days);
        saveRoute(fsa, days);
        showRoute();
        offerReminder(form, fsa, days);
      }).catch(function () {
        form.removeAttribute('aria-busy');
        show('error', msg('error'));
        track('error', fsa);
      });
    });
  });

  /* ---------- Your delivery day, remembered ----------
     After a successful postal check the route (first three characters and delivery weekdays, nothing
     else) is kept on the device, and the service row shows that customer's next delivery date. */
  var ROUTE_KEY = 'fgh_route';
  function saveRoute(fsa, days) {
    try { localStorage.setItem(ROUTE_KEY, JSON.stringify({ fsa: fsa, days: days, t: Date.now() })); } catch (e) {}
  }
  function readRoute() {
    try {
      var r = JSON.parse(localStorage.getItem(ROUTE_KEY) || 'null');
      return r && Array.isArray(r.days) && r.days.length ? r : null;
    } catch (e) { return null; }
  }
  function shortDate(isoDate, en) {
    var p = isoDate.split('-');
    return new Intl.DateTimeFormat(en ? 'en-CA' : 'fr-CA', { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date(+p[0], +p[1] - 1, +p[2]));
  }
  function showRoute() {
    var r = readRoute();
    if (!r) return;
    var next = nextDelivery(r.days);
    if (!next) return;
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    document.querySelectorAll('[data-fgh-route-title]').forEach(function (el) {
      var title = el.querySelector('.fgh-service__title');
      var sub = el.querySelector('.fgh-service__sub');
      if (title) title.textContent = el.getAttribute('data-fgh-route-title').replace('{days}', joinDays(r.days, en));
      var soon = el.getAttribute('data-fgh-route-soon');
      if (sub && soon && next.offset === 1) {
        var now = nowInStoreTz();
        sub.textContent = soon.replace('{left}', leftLabel(24 * 60 - now.mins, en));
      } else if (sub) {
        sub.textContent = (el.getAttribute('data-fgh-route-text') || '{date}').replace('{date}', shortDate(next.date, en));
      }
      el.classList.add('is-personal');
    });
  }
  showRoute();

  /* ---------- Live pickup countdown ----------
     On an open day before the cut-off hour (15 h): "Prêt aujourd'hui si commandé d'ici 2 h 14".
     Otherwise: "Commandé maintenant, prêt demain" (or the next open day: Monday to Saturday, closures
     skipped, from the store calendar). Refreshed every minute. */
  function leftLabel(mins, en) {
    mins = Math.max(0, mins);
    var h = Math.floor(mins / 60), m = mins % 60;
    if (!h) return m + ' min';
    return h + ' h ' + (m < 10 ? '0' : '') + m + (en ? ' min' : '');
  }
  function updatePickup() {
    var cal = window.FGStoreCalendar;
    if (!cal) return;
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var now = nowInStoreTz();
    var today = cal.today();
    function openDay(offset) {
      var d = cal.addDays(today, offset);
      return cal.weekday(d) !== 0 && !cal.closure(d);
    }
    document.querySelectorAll('[data-fgh-live-pickup]').forEach(function (el) {
      var sub = el.querySelector('.fgh-service__sub');
      if (!sub) return;
      var cutoff = (parseFloat(el.getAttribute('data-cutoff')) || 15) * 60;
      if (openDay(0) && now.mins < cutoff && now.mins >= 6 * 60) {
        sub.textContent = (el.getAttribute('data-today') || '').replace('{left}', leftLabel(cutoff - now.mins, en));
        el.classList.add('is-live');
        return;
      }
      el.classList.remove('is-live');
      for (var i = 1; i <= 10; i++) {
        if (!openDay(i)) continue;
        var day = i === 1 ? (en ? 'tomorrow' : 'demain') : longDate(cal.addDays(today, i), en, false);
        sub.textContent = (el.getAttribute('data-next') || '').replace('{day}', day);
        return;
      }
    });
  }
  /* The pickup promise on product cards ("En stock · prêt aujourd'hui"): same rule as the service row. */
  function readyText() {
    var cal = window.FGStoreCalendar;
    if (!cal) return '';
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var now = nowInStoreTz();
    var today = cal.today();
    function openDay(offset) { var d = cal.addDays(today, offset); return cal.weekday(d) !== 0 && !cal.closure(d); }
    /* Only news: "prêt aujourd'hui" on an open day before 15 h; otherwise say nothing (the service row
       already carries the next-day promise for the whole store). */
    if (openDay(0) && now.mins < 15 * 60 && now.mins >= 6 * 60) return en ? ' · ready today' : ' · prêt aujourd\u2019hui';
    return '';
  }
  function updateReady(root) {
    var t = readyText();
    (root || document).querySelectorAll('[data-fgh-ready]').forEach(function (el) { el.textContent = t; });
    (root || document).querySelectorAll('[data-fgh-today]').forEach(function (el) { el.hidden = !t; });
  }
  /* Closure reminder: a store closure within the next ten days, from the store calendar. */
  (function () {
    var box = document.querySelector('[data-fgh-closure]');
    var cal = window.FGStoreCalendar;
    if (!box || !cal) return;
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var today = cal.today();
    for (var i = 0; i <= 10; i++) {
      var d = cal.addDays(today, i);
      var c = cal.closure(d);
      if (!c) continue;
      var name = en ? c.en : c.fr;
      var title = box.querySelector('[data-fgh-closure-title]');
      var text = box.querySelector('[data-fgh-closure-text]');
      if (i === 0) {
        title.textContent = en ? 'Our stores are closed today (' + name + ').' : 'Nos magasins sont fermés aujourd\u2019hui (' + name + ').';
        text.textContent = en ? 'Order online; pickup and delivery resume on the next open day.' : 'Commandez en ligne\u00a0: ramassage et livraison reprennent le prochain jour ouvert.';
      } else {
        title.textContent = (en ? 'Our stores will be closed ' : 'Nos magasins seront fermés ') + longDate(d, en, true) + ' (' + name + ').';
        text.textContent = en ? 'Plan your pickup or delivery before then.' : 'Prévoyez votre ramassage ou votre livraison d\u2019ici là.';
      }
      box.hidden = false;
      return;
    }
  })();
  window.__fghReady = updateReady;
  updatePickup();
  updateReady();
  setInterval(function () { updatePickup(); showRoute(); updateReady(); }, 60000);

  /* ---------- Reminder before the cut-off (optional) ----------
     Shown under a positive postal check when the section has a Klaviyo public key and list.
     Subscribes the email to that list with the route as profile properties; Klaviyo sends the
     reminder the day before each route's cut-off. */
  function offerReminder(form, fsa, days) {
    var box = form.parentNode.querySelector('[data-fgh-remind]');
    if (!box || !box.getAttribute('data-company') || !box.getAttribute('data-list')) return;
    box.hidden = false;
    box.setAttribute('data-fsa', fsa);
    box.setAttribute('data-days', days.join(','));
  }
  document.querySelectorAll('[data-fgh-remind]').forEach(function (box) {
    var f = box.querySelector('form');
    var out = box.querySelector('[data-fgh-remind-result]');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = f.querySelector('input[type=email]').value.trim();
      var consent = f.querySelector('input[type=checkbox]');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { out.textContent = box.getAttribute('data-msg-invalid'); return; }
      if (consent && !consent.checked) { out.textContent = box.getAttribute('data-msg-consent'); return; }
      var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      var days = (box.getAttribute('data-days') || '').split(',').filter(Boolean).map(Number);
      f.setAttribute('aria-busy', 'true');
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(box.getAttribute('data-company')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Accueil: rappel de livraison',
          profile: { data: { type: 'profile', attributes: { email: email, properties: {
            fge_route_fsa: box.getAttribute('data-fsa') || '',
            fge_route_days: days.join(','),
            fge_route_day_names: joinDays(days, false),
            fge_language: en ? 'en' : 'fr'
          } } } }
        }, relationships: { list: { data: { type: 'list', id: box.getAttribute('data-list') } } } } })
      }).then(function (r) {
        f.removeAttribute('aria-busy');
        if (!r.ok) throw new Error('http');
        f.hidden = true;
        out.textContent = box.getAttribute('data-msg-ok');
        send('fg_home_local_action', { section: 'local-service', section_variant: 'reminder', section_position: 0, item: 'route-reminder', item_position: 0, action: 'reminder_signup', fsa: box.getAttribute('data-fsa') || '', route_days: days.join(',') });
      }).catch(function () {
        f.removeAttribute('aria-busy');
        out.textContent = box.getAttribute('data-msg-error');
      });
    });
  });

  /* ---------- Rendered rails (shared) ----------
     Fills a rail <ul> from a renderer section (fg-home-rail-render, fg-home-reco-render,
     fg-home-card-render) and wires the desktop arrows. Returns the number of cards placed. */
  function fillRail(ul, html, skipShown) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var lists = doc.querySelectorAll('[data-fgh-render]');
    var items = [];
    lists.forEach(function (l) { Array.prototype.forEach.call(l.children, function (li) { items.push(li); }); });
    ul.innerHTML = '';
    var seen = {};
    /* New arrivals and suggestions skip products already shown elsewhere on the page. */
    if (skipShown) {
      document.querySelectorAll('main [data-fgh-product]').forEach(function (c) { seen[c.getAttribute('data-fgh-product')] = 1; });
    }
    items.forEach(function (li) {
      if (ul.children.length >= 12) return;
      var card = li.querySelector('[data-fgh-product]');
      var h = card ? card.getAttribute('data-fgh-product') : '';
      if (h && seen[h]) return;
      seen[h] = 1;
      ul.appendChild(document.importNode(li, true));
    });
    if (window.__fghWireScroller) window.__fghWireScroller(ul);
    if (window.__fghReady) window.__fghReady(ul);
    return ul.children.length;
  }
  var renderCache = {};
  function getHtml(url) {
    if (!renderCache[url]) {
      renderCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); });
      renderCache[url].catch(function () { delete renderCache[url]; });
    }
    return renderCache[url];
  }
  function whenNear(el, fn) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  }

  /* ---------- Brand row: logos ready before the swipe ----------
     Lazy logos off the right edge only load once swiped into view, so the row showed empty tiles mid-swipe.
     They stay deferred until the row is near, then all load at once. */
  (function () {
    var list = document.querySelector('.fgh-brands__list');
    if (!list) return;
    whenNear(list, function () {
      list.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    });
  })();

  /* ---------- Best sellers by department ----------
     Tabs, one per department; the rail shows that collection's 12 best sellers. The chosen tab is
     remembered on the device and moves that department's tile to the front. */
  (function () {
    var root = document.querySelector('[data-fgh-profile]');
    if (!root) return;
    var KEY = 'fgh_elevage';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.fgh-profile__opt'));
    var body = root.querySelector('[data-fgh-profile-rail-body]');
    var link = root.querySelector('[data-fgh-profile-link]');
    var base = root.getAttribute('data-root') || '/';
    var catsMain = document.querySelector('[data-fgh-cats-main]');
    var catsMore = document.querySelector('[data-fgh-cats-more]');
    var visibleEl = document.querySelector('[data-fgh-visible]');
    var visible = parseInt(visibleEl ? visibleEl.getAttribute('data-fgh-visible') : '8', 10) || 8;
    var tiles = [].concat(catsMain ? Array.prototype.slice.call(catsMain.children) : [], catsMore ? Array.prototype.slice.call(catsMore.children) : []);

    function reorder(tab) {
      if (!catsMain || !tiles.length) return;
      var colls = (tab.getAttribute('data-colls') || '').split(',').filter(Boolean);
      tiles.map(function (li, i) {
        var a = li.querySelector('[data-fgh-item]');
        var r = colls.indexOf(a ? a.getAttribute('data-fgh-item') : '');
        return { el: li, i: i, r: r < 0 ? 999 : r };
      }).sort(function (a, b) { return a.r - b.r || a.i - b.i; })
        .forEach(function (x, i) { (i < visible || !catsMore ? catsMain : catsMore).appendChild(x.el); });
    }
    function select(tab, fromUser) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
      if (link) link.setAttribute('href', (tab.getAttribute('data-url') || '#') + '?sort_by=best-selling');
      var handle = tab.getAttribute('data-rail');
      if (!handle) return;
      body.setAttribute('aria-busy', 'true');
      var railUrl = base + 'collections/' + encodeURIComponent(handle) + '?section_id=fg-home-rail-render&sort_by=best-selling';
      getHtml(railUrl)
        .catch(function () {
          /* One retry, past any cached failure. */
          return new Promise(function (r) { setTimeout(r, 1200); }).then(function () { return getHtml(railUrl + '&retry=1'); });
        })
        .then(function (html) {
          body.removeAttribute('aria-busy');
          if (tab.getAttribute('aria-selected') !== 'true') return;
          var isAll = tab.getAttribute('data-key') === 'tout';
          /* "Tout" skips products already on the page; if that leaves too few, show the plain list. */
          if (fillRail(body, html, isAll) < 4 && isAll) fillRail(body, html, false);
          /* The department's number one gets the wide feature card and a badge. */
          var first = body.firstElementChild;
          var top = root.getAttribute('data-fgh-top-label');
          if (first) {
            first.classList.add('fgh-rail__feature');
            var media = first.querySelector('.fgh-card__media');
            if (top && media) {
              var badge = document.createElement('span');
              badge.className = 'fgh-card__top';
              badge.textContent = isAll ? top : top + ' · ' + (tab.getAttribute('data-label') || '');
              media.appendChild(badge);
            }
          }
        })
        .catch(function () { body.removeAttribute('aria-busy'); });
      if (fromUser) {
        try { localStorage.setItem(KEY, JSON.stringify([tab.getAttribute('data-key')])); } catch (e) {}
        reorder(tab);
        send('fg_home_click', { section: 'best-sellers', section_variant: '', section_position: 0, item: tab.getAttribute('data-key'), item_position: tabs.indexOf(tab) + 1, action: 'department_tab' });
      }
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { select(t, true); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); select(n, true);
        }
      });
    });
    var saved = [];
    try { saved = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    var initial = tabs.filter(function (t) { return saved.indexOf(t.getAttribute('data-key')) > -1; })[0];
    if (initial) { reorder(initial); initial.scrollIntoView && root.querySelector('.fgh-profile__opts').scrollTo({ left: initial.offsetLeft - 16 }); }
    whenNear(root, function () { select(initial || tabs[0], false); });
  })();

  /* ---------- Feeds: new arrivals, suggestions, recently viewed ---------- */
  function readSeen() {
    try { var a = JSON.parse(localStorage.getItem('fgh_seen') || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  document.querySelectorAll('[data-fgh-feed]').forEach(function (sec) {
    var kind = sec.getAttribute('data-fgh-feed');
    var ul = sec.querySelector('[data-fgh-feed-body]');
    var base = sec.getAttribute('data-root') || '/';
    var title = sec.querySelector('[data-fgh-feed-title]');
    function reveal(n, min) {
      sec.removeAttribute('data-fgh-pending');
      if (n < (min || 1) && !(window.Shopify && Shopify.designMode)) sec.hidden = true;
    }
    whenNear(sec, function () {
      if (kind === 'collection') {
        var handle = sec.getAttribute('data-collection') || 'all';
        var sort = sec.getAttribute('data-sort');
        getHtml(base + 'collections/' + encodeURIComponent(handle) + '?section_id=fg-home-rail-render' + (sort && sort !== 'manual' ? '&sort_by=' + sort : ''))
          .then(function (html) { reveal(fillRail(ul, html, true), 4); }).catch(function () { reveal(0); });
      } else if (kind === 'suggestions') {
        fetch(base + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; })
          .then(function (cart) {
            var fromCart = cart && cart.items && cart.items.length ? cart.items[0].product_id : null;
            var seen = readSeen();
            var id = fromCart || (seen[0] && seen[0].id);
            if (!id) return reveal(0);
            if (title) title.textContent = sec.getAttribute(fromCart ? 'data-heading-cart' : 'data-heading-seen') || title.textContent;
            var intent = fromCart ? 'complementary' : 'related';
            var url = base + 'recommendations/products?product_id=' + id + '&limit=12&intent=' + intent + '&section_id=fg-home-reco-render';
            return getHtml(url).then(function (html) {
              var n = fillRail(ul, html, true);
              if (n < 4 && intent === 'complementary') {
                return getHtml(base + 'recommendations/products?product_id=' + id + '&limit=12&intent=related&section_id=fg-home-reco-render')
                  .then(function (h2) { reveal(fillRail(ul, html + h2, true), 4); });
              }
              reveal(n, 4);
            });
          }).catch(function () { reveal(0); });
      } else if (kind === 'recent') {
        var seen = readSeen().slice(0, 12);
        if (seen.length < 2) return reveal(0);
        Promise.all(seen.map(function (p) {
          return getHtml(base + 'products/' + encodeURIComponent(p.h) + '?section_id=fg-home-card-render').catch(function () { return ''; });
        })).then(function (parts) { reveal(fillRail(ul, parts.join('')), 2); });
      }
    });
  });


  /* ---------- Arrows for long rails (desktop) ---------- */
  function wireScroller(ul) {
    if (!ul || ul.__fghScroller || !ul.classList.contains('fgh-rail--scroll')) return;
    ul.__fghScroller = true;
    var wrap = document.createElement('div');
    wrap.className = 'fgh-scroller';
    ul.parentNode.insertBefore(wrap, ul);
    wrap.appendChild(ul);
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    function btn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fgh-scroller__btn fgh-scroller__btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? (en ? 'Previous products' : 'Produits précédents') : (en ? 'Next products' : 'Produits suivants'));
      b.innerHTML = dir === 'prev'
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';
      b.addEventListener('click', function () { ul.scrollBy({ left: (dir === 'prev' ? -1 : 1) * ul.clientWidth * 0.9, behavior: 'smooth' }); });
      wrap.appendChild(b);
      return b;
    }
    var prev = btn('prev'), next = btn('next');
    function sync() {
      prev.disabled = ul.scrollLeft < 8;
      next.disabled = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 8;
    }
    ul.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }
  window.__fghWireScroller = wireScroller;
  document.querySelectorAll('.fgh-rail--scroll').forEach(wireScroller);

  // Gentle reveal: banners, posters and section titles below the fold fade up once as they arrive.
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        revealIo.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.fgh-banner, .fgh-pbanner, .fgh-affiche, .fgh-season__panel, .fgh-head').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('fgh-reveal');
      revealIo.observe(el);
    });
    // Safety net: a fast fling can outrun the observer; anything already above the fold is shown.
    var revealTick = false;
    function revealPassed() {
      revealTick = false;
      var left = document.querySelectorAll('.fgh-reveal:not(.is-in)');
      if (!left.length) { window.removeEventListener('scroll', onRevealScroll); return; }
      left.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); });
    }
    function onRevealScroll() { if (!revealTick) { revealTick = true; requestAnimationFrame(revealPassed); } }
    window.addEventListener('scroll', onRevealScroll, { passive: true });
  }

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
